export default __webpack_public_path__ + "static/team-2-f6bb386f1fe6ec5df103e17bc442d149.jpg";